module.exports = __webpack_public_path__ + "media/images/gallery/star_tab_off-a1c5f524a22a53b1e59c39e1bfb8be94.jpg";